import styled from 'styled-components';
import { breakpoints } from 'themes/helpers';
import isPropValid from '@emotion/is-prop-valid';
import { CardProps } from './Card.types';

export const Wrapper = styled.div.withConfig({
  shouldForwardProp: (prop) => isPropValid(prop),
})<CardProps>`
  margin: 0 auto;
  width: 100%;
  flex: 1;

  @media (min-width: ${() => breakpoints.tablet}px) {
    padding-top: ${({ theme }) => theme.space(24)}px;
    max-width: ${({ isWide }) => (isWide ? '600px' : '452px')};
    width: auto;
  }
`;

export const Body = styled.div`
  background: ${({ theme }) => theme.palette.neutral.surface};
  padding: ${({ theme }) => theme.space(4)}px;

  @media (min-width: ${() => breakpoints.tablet}px) {
    border: 1px solid ${({ theme }) => theme.palette.neutral.neutral30};
    border-radius: 16px;
    padding: ${({ theme }) => theme.space(8)}px;
    margin: 0 auto;
  }
`;
